var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../..';
import { IconName, IconSize } from '../../Atoms/Icon/Icon.enum';
import handleTagBackground from './Tag.helpers';
const BaseTag = styled.div `
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text01};
  padding: ${({ big }) => (big ? '8px 10px' : '4px 8px')};
  background-color: ${({ theme, variant }) => handleTagBackground(theme, variant)};
  ${({ error, theme }) => (error ? `border: 1px solid ${theme.colors.supportError01};` : '')}

  & > svg {
    margin-left: 4px;
  }
`;
const Tag = (_a) => {
    var { big, error, variant, children, keepAfterDelete, closeIcon, onClick } = _a, delegated = __rest(_a, ["big", "error", "variant", "children", "keepAfterDelete", "closeIcon", "onClick"]);
    const [active, setActive] = useState(true);
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        if (!keepAfterDelete) {
            setActive(false);
        }
    };
    return active ? (_jsxs(BaseTag, Object.assign({ big: big, "data-testid": "tag", error: error, onClick: () => handleClick(), variant: variant }, delegated, { children: [children, closeIcon && _jsx(Icon, { name: IconName.CLOSE, size: IconSize.SIZE16 }, void 0)] }), void 0)) : null;
};
export default Tag;
//# sourceMappingURL=Tag.js.map